import LayoutBasic from '@/layouts/basic'

const meta = {
  auth: true,
}

const pre = 'faq-'

export default {
  path: '/faq',
  name: 'faq',
  redirect: {
    name: `${pre}list`,
  },
  meta,
  component: LayoutBasic,
  children: [
    {
      path: 'list',
      name: `${pre}list`,
      meta: {
        ...meta,
        title: '帮助中心',
      },
      component: () => import('@/views/faq/list'),
    },
  ],
}
